<script>
const url = "https://ipfs.infura.io/ipfs/QmU272qrKY9LGNBFqHVUkVgycdvSs766L2hAsRUELYr19B"

export default {
  async created() {
    try {
      let res = await fetch(url)
      if (!res.ok) throw new Error()
    } catch (err) {
      this.$notify({
        title: "⚠️ IPFS Issues",
        type: "error",
        duration: -1,
        text:
          "We are having problems connecting to IPFS. This may affect some interactions on Matryx. Please try again later."
      })
    }
  },
  render(h) {
    return h()
  }
}
</script>
